





















import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { User, Worker, Patient } from '@/types/user'

@Component({
  components: {
    CallCheckboxInput: () => import('@/components/call/CallCheckboxInput.vue')
  }
})
export default class CallUserList extends Vue {
  $store!: ExStore
  checkedUsers: number[] = []

  @Prop({ default: [] }) users!: (Worker | Patient)[]

  getName(user: User) {
    return `${user.lastName}${user.firstName} (${user.lastNameReading}${user.firstNameReading})`
  }
}
